/* eslint 'array-callback-return': 'off', eqeqeq: 'off' */
import React, { Component } from 'react';
import { connect } from "react-redux";
import { Table, Button, Modal, FormGroup, Col } from 'reactstrap';
import classnames from 'classnames';
import '../../../../../../Assets/EnsembleStyles/Filter.css';
import ErrorGif from '../../../../../../Assets/images/Error.gif';
import { GetZonesList } from '../../../../../../action/ZonesAction';
import { PutZonesAction, UnAssociateZone } from '../../../../../../action/tenantAction';
import AdditionalDeleteConfirmation from '../../_ModalsForms/AdditionalDeleteConfirmation';
import { closeModalPopUp } from '../../../../../../action/modalStateAction';
import SearchInput, { createFilter } from 'react-search-input';
import SelectAllCheckboxes from '../../../../../../Resources/SelectAllCheckboxes';

const KEYS_TO_FILTERS = ['zoneName', 'buildingName', 'members.objectName'];

class Zones extends Component {
    componentWillMount(){
        this.props.GetZonesList();
    }
    constructor(props) {
        super(props);
        this.state = {
            modal: false,
            Deletemodal: false,
            error_msg: false,
            selected_Check_Boxes: [],
            searchTerm: '',
            tenant_zones: this.props.TenantZones_response,
            TenantID: this.props.TenantId,
            sort:{
                column: 'zoneName',
                direction:[
                    {name:'zoneName', direction:'asc', onclick:true},
                    {name:'buildingName', direction:'desc', onclick:false},
                    {name:'members', direction:'desc', onclick:false},
                ],
            },
            sortModal:{
                column: 'zoneName',
                direction:[
                    {name:'zoneName', direction:'asc', onclick:true},
                    {name:'buildingName', direction:'desc', onclick:false},
                    {name:'members', direction:'desc', onclick:false},
                ],
            },
            IsDefaultSort: true,
            IsDefaultSortModal: true,
            IsChangesSaved: false
        };
        this.searchUpdated = this.searchUpdated.bind(this);
        this.toggle = this.toggle.bind(this);
        this.Deletetoggle = this.Deletetoggle.bind(this);
        this.deleteZones = this.deleteZones.bind(this);
        this.SaveSelectedZones = this.SaveSelectedZones.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if (this.props != nextProps) {
            let Zones = nextProps.TenantZones_response === undefined ? "" : nextProps.TenantZones_response;
            this.setState({
                tenant_zones: Zones,
                TenantID: nextProps.TenantId,
                IsChangesSaved: true
            });
        }
    }

    SaveSelectedZones() {
        var Data = [];
        var checkboxes = document.getElementsByClassName('AvailableZoneRows');
        for (var i = 0; i < checkboxes.length; i++) {
            if (checkboxes[i].checked === true) {
                var Zone_id_to_be_deleted = {
                    "zoneId": checkboxes[i].id
                }
                Data.push(Zone_id_to_be_deleted);
            }
        }
        this.props.PutZonesAction(Data, this.state.TenantID);
        this.toggle();
        this.setState({IsChangesSaved: true});
    }

    toggle() {
        this.setState({
            modal: !this.state.modal
        });
    }
    Deletetoggle() {
        this.setState({
            Deletemodal: !this.state.Deletemodal
        });
    }
    deleteZones(){
        this.setState({error_msg:false});
        var IsAnyChecked = false;
        var checkboxes = document.getElementsByClassName('AssociatedZoneRows');
        for (var i = 0; i < checkboxes.length; i++) {
            if (checkboxes[i].checked === true) {
                IsAnyChecked = true;
            }
        }
        if(IsAnyChecked) this.Deletetoggle();
        else this.setState({error_msg:true});
    }
    /* Delete Confirmation*/
    Delete = (someArg) => {
        var IsCheck = someArg.split(',')
        if (IsCheck[0] == "yes") {
            var Data = [];
            var checkboxes = document.getElementsByClassName('AssociatedZoneRows');
            for (var i = 0; i < checkboxes.length; i++) {
                if (checkboxes[i].checked === true) {
                    var Zone_id_to_be_deleted = {
                        "zoneId": checkboxes[i].id
                    }
                    Data.push(Zone_id_to_be_deleted);
                }

            }
            if (Data.length > 0) {
                this.setState({ error_msg: false });
                var IsFutReqDelete = document.getElementsByClassName(IsCheck[1]);
                this.props.UnAssociateZone(Data, this.state.TenantID, IsFutReqDelete[0].checked);
                this.Deletetoggle();
            }
            else {
                this.setState({ error_msg: true });
                this.Deletetoggle();
            }

        }
        else {
            this.Deletetoggle();
        }
    }

    onSort = (column) => (e) => {
        this.setState({IsDefaultSort:false});
        var SortData = this.state.sort.direction;
        var selected = SortData.filter(a => a.name == column);
        const direction = selected[0] ? (selected[0].direction === 'asc' ? 'desc' : 'asc') : 'asc';
        var data_from_state = this.state.tenant_zones;
        var notequals = 0;

       if(data_from_state != null){
        const sortedData = this.state.tenant_zones.sort((a, b) => {
            const nameA = (column == 'members') ? a[column].map(xl => (xl.objectName)).join(', ').toLowerCase() : (column == 'tenantNames') ? a[column].join(', ').toLowerCase() : a[column].toLowerCase();
            const nameB = (column == 'members') ? b[column].map(xl => (xl.objectName)).join(', ').toLowerCase() : (column == 'tenantNames') ? b[column].join(', ').toLowerCase() : b[column].toLowerCase();
            if (nameA < nameB) {
                notequals = 1;
                return -1;
            }
            if (nameA > nameB) {
                notequals = 1;
                return 1;
            }
            if (nameA == nameB) {
                return 0;
            }
            return 0;
        });

        if(selected[0].direction =='asc' && notequals == 1){
        sortedData.reverse();
     }

     SortData.map(x => (x.name !== column) ? x.onclick = false : x.onclick = true);
     SortData.map(x => (x.name !== column) ? x.direction = SortData.filter(m => (m.name === x.name))[0].direction : x.direction = direction);

        this.setState({
            tenant_zones: sortedData,
            sort: {
                column,
                direction:SortData,
            }
        });
       }
    }

    setArrow = (column) => {
        let className = 'workorder-sort-direction';
        let sortColumn = this.state.sort.direction.filter(x => (x.name === column))[0];
        className += (sortColumn.onclick === true) ? (sortColumn.direction === 'asc') ? ' asccolor' : ' desccolor' : ' desc';
        return className;
    };

    onSortModal = (column) => (e) => {
        this.setState({IsDefaultSortModal:false});
        var SortData = this.state.sortModal.direction;
        var selected = SortData.filter(a => a.name == column);
        const direction = selected[0] ? (selected[0].direction === 'asc' ? 'desc' : 'asc') : 'asc';
        var data_from_state = this.props.getResponse.ZonesList;
        var notequals = 0;

       if(data_from_state != null){
        const sortedData = this.props.getResponse.ZonesList.sort((a, b) => {
            const nameA = (column == 'members') ? a[column].map(xl => (xl.objectName)).join(', ').toLowerCase() : (column == 'tenantNames') ? a[column].join(', ').toLowerCase() : a[column].toLowerCase();
            const nameB = (column == 'members') ? b[column].map(xl => (xl.objectName)).join(', ').toLowerCase() : (column == 'tenantNames') ? b[column].join(', ').toLowerCase() : b[column].toLowerCase();
            if (nameA < nameB) {
                notequals = 1;
                return -1;
            }
            if (nameA > nameB) {
                notequals = 1;
                return 1;
            }
            if (nameA == nameB) {
                return 0;
            }
            return 0;
        });

        if(selected[0].direction =='asc' && notequals == 1){
        sortedData.reverse();
     }

     SortData.map(x => (x.name !== column) ? x.onclick = false : x.onclick = true);
     SortData.map(x => (x.name !== column) ? x.direction = SortData.filter(m => (m.name === x.name))[0].direction : x.direction = direction);

     this.props.getResponse.ZonesList = sortedData;
        this.setState({
            sortModal: {
                column,
                direction:SortData,
            }
        });
       }
    }

    setArrowModal = (column) => {
        let className = 'workorder-sort-direction';
        let sortColumn = this.state.sortModal.direction.filter(x => (x.name === column))[0];
        className += (sortColumn.onclick === true) ? (sortColumn.direction === 'asc') ? ' asccolor' : ' desccolor' : ' desc';
        return className;
    };
    /* Modal Pop ups*/

    render(TenantZones_response,getLabels ,getResponse, TenantId, UserCanEdit) {
        let label = this.props.getLabels;
        let lUserCanEdit;
        let Zones, Error_Message, ZonedList, FilteredData, SelectedZoneIds = [], modal_form_1, Available_Zones = [], ZoneList;

        lUserCanEdit = this.props.UserCanEdit;
        lUserCanEdit = lUserCanEdit !== undefined && lUserCanEdit !== null && lUserCanEdit ? true : false;
      
        if (this.state.tenant_zones != undefined && this.props.getResponse != undefined) {
            if (this.state.tenant_zones.length) {
                ZonedList = this.state.tenant_zones;
                
                if(this.state.IsDefaultSort){  // default sorting for tenant zones
                    ZonedList.sort((a,b)=>{
                        let nameA = a['zoneName'].toLowerCase();
                        let nameB = b['zoneName'].toLowerCase();
                        if(nameA < nameB){
                            return -1;
                        }
                        if(nameA > nameB){
                            return 1;
                        }
                        if(nameA == nameB){
                            return 0;
                        }
                        return 0;
                    });
                }

                if(this.state.IsChangesSaved){ //sorting when zones added to the tenant
                    ZonedList.sort((a,b) => {
                        let nameA = (this.state.sort.column == 'members') ? a[this.state.sort.column].map(xl => (xl.objectName)).join(', ').toLowerCase() : a[this.state.sort.column].toLowerCase();
                        let nameB = (this.state.sort.column == 'members') ? b[this.state.sort.column].map(xl => (xl.objectName)).join(', ').toLowerCase() : b[this.state.sort.column].toLowerCase();
                        if(nameA < nameB){
                            return -1;
                        }
                        if(nameA > nameB){
                            return 1;
                        }
                        if(nameA == nameB){
                            return 0;
                        }
                    });
                    if(this.state.sort.direction.filter(x => x.name === this.state.sort.column)[0].direction === "desc"){
                        ZonedList.reverse();
                    }
                    this.setState({IsChangesSaved:false})
                }

                ZoneList = this.props.getResponse.ZonesList;
                this.state.tenant_zones.map(el => (
                    SelectedZoneIds.push(el.zoneId)
                ));
                if (ZoneList != undefined && ZoneList != null && ZoneList.length) {
                    // ZoneList = ZoneList.filter(function (item) {
                    //     return SelectedZoneIds.join(',').search(item.zoneId) === -1
                    // });
                    ZoneList = ZoneList.filter((obj) => {
                        let HasId = false;
                        for (let i = 0, length = SelectedZoneIds.length; i < length; i++) {
                            if (obj.zoneId === SelectedZoneIds[i]) HasId = true;
                        }
                        if(!HasId) return true;
                    })
                }
                if (ZoneList.length) {
                    if(this.state.IsDefaultSortModal){ //default sorting for available zones
                        ZoneList.sort((a,b)=>{
                            let nameA = a['zoneName'].toLowerCase();
                            let nameB = b['zoneName'].toLowerCase();
                            if(nameA < nameB){
                                return -1;
                            }
                            if(nameA > nameB){
                                return 1;
                            }
                            if(nameA == nameB){
                                return 0;
                            }
                            return 0;
                        });
                    }
                    Available_Zones = ZoneList.map(el => (
                        <tr key={el.zoneId}>
                            <td><input type="checkbox" id={el.zoneId} className="AvailableZoneRows" onClick={() => { SelectAllCheckboxes.ResetHeaderCheckBox("AvailableZoneRows", "AvailZones_header_Check_box"); }} /></td>
                            <td>{el.zoneName}</td>
                            <td>{el.buildingName}</td>
                            <td>{el.members.map(xl => (xl.objectName)).join(", ")}</td>
                        </tr>
                    ));               
                }
                else{
                    Available_Zones = <tr> <td colSpan="4">No Records Found</td> </tr>
                }

                FilteredData = ZonedList.filter(createFilter(this.state.searchTerm, KEYS_TO_FILTERS));
                Zones = (FilteredData.length > 0) ? FilteredData.map(el => (
                    <tr key={el.zoneId}>
                        <td><input type="checkbox" id={el.zoneId} className="AssociatedZoneRows" onClick={() => { SelectAllCheckboxes.ResetHeaderCheckBox("AssociatedZoneRows", "main_Check_box"); }} /></td>
                        <td >{el.zoneName}</td>
                        <td>{el.buildingName}</td>
                        <td> {el.members.map(xl => (xl.objectName)).join(", ")}</td>
                    </tr>
                )) : <tr> <td colSpan="4">No Records Found</td> </tr>;
            }
            else {
                Zones = <tr> <td colSpan="4">No Records Found</td> </tr>
                let ZonesList = this.props.getResponse.ZonesList;
                if (ZonesList !== undefined && ZonesList !== null && ZonesList.length) {
                    if(this.state.IsDefaultSortModal){ //default sorting for available zones
                        ZonesList.sort((a,b)=>{
                            let nameA = a['zoneName'].toLowerCase();
                            let nameB = b['zoneName'].toLowerCase();
                            if(nameA < nameB){
                                return -1;
                            }
                            if(nameA > nameB){
                                return 1;
                            }
                            if(nameA == nameB){
                                return 0;
                            }
                            return 0;
                        });
                    }
                    Available_Zones = ZonesList.map(el => (
                        <tr key={el.zoneId}>
                            <td><input type="checkbox" id={el.zoneId} className="AvailableZoneRows" onClick={() => { SelectAllCheckboxes.ResetHeaderCheckBox("AvailableZoneRows", "AvailZones_header_Check_box"); }} /></td>
                            <td>{el.zoneName}</td>
                            <td>{el.buildingName}</td>
                            <td>{el.members.map(xl => (xl.objectName)).join(", ")}</td>
                        </tr>
                    ));                   
                }              
            }
        }
        // else {
        //     Zones = <p>Loading Data</p>
        // }
        // Error Message

        (this.state.error_msg == true) ? Error_Message = <p className="error_msg"> <img src={ErrorGif} alt="Trane Logo" />  Error: Select one or more Zone to perform this action.</p> : Error_Message = " ";

        modal_form_1 = <div className="table_container">
            {Error_Message}
            <legend className="form_sub_title">{label['TenantZones.AddExistingZone.Text'] !== undefined ? label['TenantZones.AddExistingZone.Text'] : "Add Zone"}</legend>
            <Table striped responsive className="Custom_table table_border">
                <tbody className="cell_container tenant_cell">
                    <tr>
                        <th width="5%"><input type="checkbox" className="AvailZones_header_Check_box" onClick={() => { SelectAllCheckboxes.selectAllCheckbox("AvailableZoneRows", "AvailZones_header_Check_box"); }} /></th>
                        <th width="30%" onClick={this.onSortModal('zoneName')}>{label['DefaultTemplate.Zone.Text'] !== undefined ? label['DefaultTemplate.Zone.Text'] : "Zone"}<span className={this.setArrowModal('zoneName')}></span></th>
                        <th width="25%" onClick={this.onSortModal('buildingName')}>{label['TenantZones.Building.Text'] !== undefined ? label['TenantZones.Building.Text'] : "Building"}<span className={this.setArrowModal('buildingName')}></span></th>
                        <th width="40%" onClick={this.onSortModal('members')}>{label['TenantZones.Members.Text'] !== undefined ? label['TenantZones.Members.Text'] : "Members"}<span className={this.setArrowModal('members')}></span></th>
                    </tr>                   
                    {Available_Zones}
                </tbody>
            </Table>
            <FormGroup row className="btns_group">
                <Col sm={{ size: 10 }}>
                    <Button className="btn-gray btn-md" onClick={this.toggle}> {label['CreateTenant.Cancel.Text'] !== undefined ? label['CreateTenant.Cancel.Text'] : "Cancel"} </Button>
                    <Button className="btn-success btn-md" onClick={() => { this.SaveSelectedZones(Available_Zones); }} >{label['Buttons.Apply.Text'] !== undefined ? label['Buttons.Apply.Text'] : "Apply"}</Button>
                </Col>
            </FormGroup>
        </div>

        return (
            <div className="main_container">
                {Error_Message}

                <div className="buttons_container">

                    <Button type="button" hidden={!lUserCanEdit} className="btn btn-black" onClick={this.deleteZones}>{label['TenantZones.Remove.Text'] !== undefined ? label['TenantZones.Remove.Text'] : "Remove"} </Button>
                    <Button type="button" hidden={!lUserCanEdit} className="btn btn-success" onClick={this.toggle}>{label['TenantZones.AddExistingZone.Text'] !== undefined ? label['TenantZones.AddExistingZone.Text'] : "Add Zone"} </Button>
                    <SearchInput className="search-input" onChange={this.searchUpdated} />

                </div>

                <div className="table_container">
                    <Table striped responsive className="Custom_table table_border">
                        <tbody className="cell_container tenant_cell">
                            <tr>
                                <th width="5%"><input type="checkbox" className="main_Check_box" onClick={() => { SelectAllCheckboxes.selectAllCheckbox("AssociatedZoneRows", "main_Check_box"); }} /></th>
                                <th width="30%" onClick={this.onSort('zoneName')}>{label['DefaultTemplate.Zone.Text'] !== undefined ? label['DefaultTemplate.Zone.Text'] : "Zone"}<span className={this.setArrow('zoneName')}></span></th>
                                <th width="25%" onClick={this.onSort('buildingName')}>{label['TenantZones.Building.Text'] !== undefined ? label['TenantZones.Building.Text'] : "Building"}<span className={this.setArrow('buildingName')}></span></th>
                                <th width="40%" onClick={this.onSort('members')}>{label['TenantZones.Members.Text'] !== undefined ? label['TenantZones.Members.Text'] : "Members"}<span className={this.setArrow('members')}></span></th>
                            </tr>
                            {Zones}
                        </tbody>
                    </Table>



                </div>
                <Modal isOpen={this.state.modal} toggle={this.toggle} className={classnames({ classnames: this.props.className }, "ModalContainer")} >
                    {modal_form_1}
                </Modal>
                <Modal isOpen={this.state.Deletemodal} Deletemodal={this.Deletemodal} className={classnames({ classnames: this.props.className }, "ModalContainer")} >
                    <AdditionalDeleteConfirmation parentToChildData={["Remove Zone(s)", "You are about to Remove Zone(s). Check the box if you want to delete all future after hours requests that the employee made.","Delete Zone's future after hours requests"]} Delete={this.Delete} />
                </Modal>
            </div>
        );
    }

    searchUpdated(term) {
        this.setState({ searchTerm: term })
    }

}

const mapStateToProps = state => {
    return {
        getResponse: state.zonesRootReducer,
        getLabels: state.CulturalLabelsRootReducer.LabelsBasedOnPreference,
        TenantZones_response: state.ViewtenantsRootReducer.TenantZones,
        TenantId: state.ViewtenantsRootReducer.TenantDetails.tenantId,
        UserCanEdit: state.authService.HasApplicationFullAcess
    };
};

const mapDispatchToProps = dispatch => {
    return {
        GetZonesList: () => dispatch(GetZonesList()),
        UnAssociateZone: (data, id, IsDeleteFutReq) => dispatch(UnAssociateZone(data, id, IsDeleteFutReq)),
        PutZonesAction: (data, id) => dispatch(PutZonesAction(data, id)),
        closeModalPopUp: (modaldata) => dispatch(closeModalPopUp(modaldata))

    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Zones);





